'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var configure = require('../lib/configure.js');

var toUrlSearchParams = require('../lib/to-url-search-params.js');

var HTTP = require('ipfs-utils/src/http.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var HTTP__default = /*#__PURE__*/_interopDefaultLegacy(HTTP);

const createRm = configure.configure(api => {
  async function rm(path) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const res = await api.post('files/rm', {
      signal: options.signal,
      searchParams: toUrlSearchParams.toUrlSearchParams({
        arg: path,
        ...options
      }),
      headers: options.headers
    });
    const body = await res.text();

    if (body !== '') {
      const error = new HTTP__default["default"].HTTPError(res);
      error.message = body;
      throw error;
    }
  }

  return rm;
});
exports.createRm = createRm;